(function ($) {

    const initializeBlock = function ($block) {
      function checkSide() {
        var marginRight = parseInt($block.find('.container').css('margin-right'))
        var paddingRight = parseInt($block.find('.container').css('padding-right'))
        var calculation = marginRight + paddingRight
        if (calculation > 200) {
          calculation = 200
        }

        calculation = calculation * -1

        $block.find('.fleetFooter-items').css('margin-right', calculation + 'px');
      }
      checkSide();
      $( window ).bind('resize orientationchange', function() {
          checkSide();
      });
    }

    $(document).ready(function () {
        $('.block--fleet-footer').each(function () {
            initializeBlock($(this));
        })
    })

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=fleet-footer', initializeBlock);
    }

})(jQuery);
